import axios from 'axios'

export default class OrganizationService {
  static async searchOrganization (name, number) {
    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/organization/', {
        params: {
          name: name ? name : null,
          organizationNumbers: number ? number : null,
          isActive: true,
          pageSize: 10
        }
      })
      .then(response => response.data.response)
  }

  static async deleteOrganization (organizationNumber) {
    await axios
      .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/organization/' + organizationNumber)
  }

  static async deleteDepartment (departmentId) {
    await axios
      .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/department/' + departmentId)
  }
}
